import { useMutation } from '@tanstack/react-query';
import { apiClient } from '@copro/api';
import { enqueueSnackbar } from '../../../components/GlobalSnackbar/snackbarStore';
import { ONBOARDING_COMPLETED_KEY } from '../utils/shouldShowOnboarding';

const RETRY_COUNT = 2;

async function completeOnboarding() {
  // Auth metadata is the user's own: readers can write it even though the space is read-only for them.
  const { error } = await apiClient.auth.updateUser({
    data: { [ONBOARDING_COMPLETED_KEY]: new Date().toISOString() },
  });

  if (error) {
    throw error;
  }
}

export default function useCompleteOnboarding() {
  return useMutation({
    mutationFn: completeOnboarding,
    retry: RETRY_COUNT,
    onError: () => {
      enqueueSnackbar("La présentation n'a pas pu être enregistrée : elle vous sera proposée à nouveau.", 'error');
    },
  });
}
